import React from "react"
import {
  IoChevronForwardOutline,
  IoChevronDownOutline,
  IoChevronUpOutline,
} from "react-icons/io5"
import ConditionalLink from "../../../utilities/ConditionalLink"
import classNames from "classnames"
import classes from "./MenuListItem.module.css"
import CustomListItem from "../../CustomListItem"
import { Collapse } from "../../../animations"

type ListItemType = "simple" | "navigable" | "expandable"

export interface MenuListItemInput {
  icon?: React.ReactNode
  content: React.ReactNode
  subtitle?: React.ReactNode
  subItems?: MenuListItemInput[]
  link?: string
  onItemClick?: () => void
  onNavigationClick?: () => void
}

const listItemType = (item: MenuListItemInput): ListItemType => {
  if (item.onNavigationClick || item.onItemClick) {
    return "navigable"
  }

  if ((item.subItems?.length ?? 0) > 0) {
    return "expandable"
  }

  return "simple"
}

interface MenuSectionItemProps {
  item: MenuListItemInput
  px?: number
  topBorder?: boolean
  bottomBorder?: boolean
  center?: boolean
}

const MenuListItem = ({
  item,
  topBorder,
  bottomBorder,
}: MenuSectionItemProps) => {
  const [expanded, setExpanded] = React.useState(false)
  const type = listItemType(item)

  const handleItemClick = () => {
    if (type === "expandable") {
      setExpanded(!expanded)
      return
    }
    item.onItemClick?.()
  }

  const handleNavigationClick = (item: MenuListItemInput) =>
    item.onNavigationClick?.() ?? item.onItemClick?.()

  return (
    <ConditionalLink link={item.link} disabled={type === "expandable"}>
      <CustomListItem
        classes={{
          startIcon: classes.startIcon,
          endIcon: classes.endIcon,
          content: classes.label,
        }}
        className={classNames(classes.listItem, {
          [classes.topBorder]: topBorder,
          [classes.bottomBorder]: bottomBorder,
        })}
        onClick={handleItemClick}
        startIcon={<div className={classes.iconContainer}>{item.icon}</div>}
        endIcon={
          <>
            {type === "navigable" && (
              <div
                className={classes.arrow}
                onClick={(event) => {
                  handleNavigationClick(item)
                  event.preventDefault()
                }}
              >
                <IoChevronForwardOutline />
              </div>
            )}
            {type === "expandable" && (
              <div
                className={classes.arrow}
                onClick={(event) => {
                  setExpanded(!expanded)
                  event.preventDefault()
                }}
              >
                {expanded ? <IoChevronUpOutline /> : <IoChevronDownOutline />}
              </div>
            )}
          </>
        }
      >
        {/* {center && <div></div>} */}
        <div className={classes.description}>
          <div className={classes.link}>
            <div className={classes.content}>{item.content}</div>
            {item.subtitle && (
              <div className={classes.subtitle}>{item.subtitle}</div>
            )}
          </div>
        </div>
      </CustomListItem>
      <Collapse in={expanded === true}>
        <div className={classes.subitemsContainer}>
          {item.subItems?.map((subitem, index) => (
            <div key={index} className={classes.subitem}>
              {subitem.content}
            </div>
          ))}
        </div>
      </Collapse>
    </ConditionalLink>
  )
}

export default MenuListItem
